import { Record } from "immutable";
import type CreateUserDto from "models/interfaces/create-user-dto";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const defaultValues: CreateUserDto =
    RecordUtils.defaultValuesFactory<CreateUserDto>({
        captchaComplete: false,
        confirmPassword: "",
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        startFreeTrial: undefined,
    });

export default class CreateUserDtoRecord
    extends Record(defaultValues)
    implements CreateUserDto
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: CreateUserDto) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<CreateUserDto>} values
     */
    public with(values: Partial<CreateUserDto>): CreateUserDtoRecord {
        return new CreateUserDtoRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
